import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Hook to manage service worker updates across the application
 * @returns Object containing needRefresh state and updateServiceWorker function
 */
export function useServiceWorkerUpdate() {
	const {
		needRefresh: [needRefresh],
		updateServiceWorker,
	} = useRegisterSW();

	return {
		needRefresh,
		updateServiceWorker,
	};
}
